import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/root/recordList/styles.scss';export default {
  "recordList": "_recordList_oruj9_1",
  "dates": "_dates_oruj9_7",
  "timeOverview": "_timeOverview_oruj9_17",
  "resource": "_resource_oruj9_21",
  "record": "_record_oruj9_1",
  "list": "_list_oruj9_25",
  "task": "_task_oruj9_29",
  "odd": "_odd_oruj9_44",
  "today": "_today_oruj9_47",
  "weekEnd": "_weekEnd_oruj9_50",
  "unAvailable": "_unAvailable_oruj9_53"
};